import moment from 'moment';

export const formatDateForTable = (value, format = 'MM/DD/YYYY') => {
  return value ? moment(value).format(format) : '';
};
